class Hero {
	constructor (el) {
		this._handleImageLoaded = this._handleImageLoaded.bind(this)
		this.el = el
		this.headerSegmentLine = this.el.querySelector('.hero__header-segment .header-segment__line')
		this.image = this.el.querySelector('.hero__image')
		this.setHeight = this.el.getAttribute('data-setheight')

		if (this.headerSegmentLine) {
			this.headerSegmentLine.style.maxHeight = `${this.headerSegmentLine.offsetHeight}px`
		}
		if (this.image) {
			if ( this.setHeight ) this.image.style.height = `${this.image.offsetHeight}px`
			const image = new Image()
			image.addEventListener('load', this._handleImageLoaded)
			image.src = this.image.getAttribute('data-src')
		}
	}

	_handleImageLoaded () {
		requestAnimationFrame(() => {
			this.image.classList.add('is-loaded')
		})
	}
}

export default Hero
